import { render, staticRenderFns } from "./AInscripcionEstadoAdministrativo.vue?vue&type=template&id=1705881a&scoped=true"
import script from "./AInscripcionEstadoAdministrativo.vue?vue&type=script&lang=js"
export * from "./AInscripcionEstadoAdministrativo.vue?vue&type=script&lang=js"
import style0 from "./AInscripcionEstadoAdministrativo.vue?vue&type=style&index=0&id=1705881a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1705881a",
  null
  
)

export default component.exports